export const clientRoutes = {
  'api.client.check-exist': 'clients/check-exist',
  'api.client.verify-code': 'clients/verify-code',
  'api.client.validation-code': 'clients/valid-code',
  'api.client.get-info': 'clients/get-info',
  'api.address.list': 'clients/contact',
  'api.add.address': 'clients/contact',
  'api.delete.address': 'clients/contact/[id]',
  'api.edit.profile': 'clients/data',
  'api.client.province-list': 'locations/province-list',
  'api.client.messages-list': 'notifications',
  'api.client.messages-mark-as-read': 'notifications/mark-as-read',
  'api.client.complaints': 'complaints',
  'api.client.complaints-types': 'complaints/type',
  'api.client.complaints-upload': 'upload/[sectionType]/[year]/[month]/[day]/[time]/image/file',
  'api.client.refund-request': 'clients/refund',
  'api.client.comments-list': 'comments/list',

  'route.client.dashboard': '/client-dashboard',
  'route.client.orders': '/client-dashboard/orders',
  'route.client.wallet': '/client-dashboard/wallet',
  'route.client.contacts-information': '/client-dashboard/contact-information',
  'route.client.login': '/client/login',
  'route.client.insurances': '/client-dashboard/insurances',
  'route.client.complaints': '/client-dashboard/complaints',
  'route.client.messages': '/client-dashboard/messages',
  'route.client.personal-info': '/client-dashboard/personal-info',
  'route.client.pharmacy-order-details': '/client-dashboard/orders/pharmacy/[id]',
  'route.client.laboratory-order-details': '/client-dashboard/orders/laboratory/[id]',
  'route.client.consult-order-details': '/client-dashboard/orders/consult/[id]',
  'route.client.medical-order-details': '/client-dashboard/orders/medical-services/[id]',
  'route.client.comments': '/client-dashboard/comments',
};
